export default "__VITE_ASSET__Hc2RfdXx__"